import React from 'react'

const Card = ({ menuData }) => {
  return (
    <>
    <div className='container' style={{display: 'flex', flexWrap: 'wrap'}}>
    {menuData.map((currElm)=>{
        return (
            <>
            <div className="card mb-3 mx-2 my-4" style={{maxWidth: "540px"}}>
            <div className="row g-0">
              <div className="col-md-4">
                <img src={currElm.image} className="img-fluid rounded-start" alt="Not-Loaded" style={{height: '100%'}} />
              </div>
              <div className="col-md-8">
                <div className="card-body">
                  <div className='up' style={{display: 'flex', gap: '120px', fontSize: '27px', fontWeight: '800'}}>
                  <h5 className="card-title" style={{fontSize: '27px'}}><strong>{currElm.name}</strong></h5>
                  <code>{currElm.price}</code>
                  </div>
                  <p className="card-text">{currElm.description}</p>
                  <button type="button" className="btn btn-outline-success" style={{fontWeight: '700', height: '40px', width: '130px'}} onClick={()=>{alert("Soory! You cant order")}}>Order Now</button>
                </div>
              </div>
            </div>
          </div>
          </>
        )
    })}
    </div>
    </>
  )
}

export default Card
